import styled from 'styled-components';

export const Td = styled.td`
  font-size: 11px;
`;

export const Th = styled.th`
  font-size: 11px;
`;
